﻿// password-reset.js
// Minimal module for handling password reset form submission.
// Replaces legacy heavy script.js.

import '../../modules/standalone/boot.js';
import { sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../../../config/firebase-config.js';
import { Logger } from '../../../config/logger.js';

function flash(message, type = 'info') {
  const box = document.getElementById('flash-container');
  const text = document.getElementById('flash-message');
  if (!box || !text) return;
  const styles = {
    success: 'bg-green-100 text-green-800 border border-green-300',
    error: 'bg-red-100 text-red-800 border border-red-300',
    info: 'bg-blue-100 text-blue-800 border border-blue-300'
  };
  box.className = `mb-4 px-4 py-3 rounded-md ${styles[type] || styles.info}`;
  text.textContent = message;
  box.classList.remove('hidden');
}

import { initializeFooter } from '../../../pages/components/footer.js';

export async function initializePasswordReset() {

  const form = document.getElementById('forgot-password-form');
  if (!form) return;
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const email = form.email.value.trim();
    if (!email) {
      flash('Please enter a valid email address.', 'error');
      return;
    }
    flash('Sending reset link...', 'info');
    try {
      await sendPasswordResetEmail(auth, email);
      flash('Reset email sent. Check your inbox.', 'success');
    } catch (err) {
      Logger.error('[password-reset] Failed to send reset email:', err);
      let msg = err.message || 'Unexpected error';
      if (err.code === 'auth/user-not-found') {
        msg = 'No account found for that email.';
      }
      flash(`Error: ${msg}`, 'error');
    }
  });
}

// --- Bootstrap Logic ---
(async function bootstrap() {
  try {
    await initializePasswordReset();
    await initializeFooter();
  } catch (e) {
    console.error("[RESET] Bootstrap Error:", e);
  }
})();


// Export noop to signal module load success if needed elsewhere.
export const PasswordResetModuleLoaded = true;
